import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaAnyNode } from './TypedNode'
import { SchemaAnyModel } from './ViewModel'

export const SchemaAnyPlugin = createSchemaPlugin(
  'Schema.Any',
  SchemaAnyModel,
  SchemaAnyNode
)
